import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// 🔔 Firebase Service Worker Register (STEP-4)
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/firebase-messaging-sw.js")
      .then((registration) => {
        console.log(
          "✅ Firebase Service Worker registered:",
          registration.scope
        );
      })
      .catch((err) => {
        console.error("❌ Service Worker registration failed:", err);
      });
  });
}